import type pino from 'pino';
import type { LoggerConfig, DatadogConfig, LoggerConstructor, DatadogLogger } from '../types';
import { PinoLogger } from './PinoLogger';
import { createDatadogSend } from '../datadog';

export const Logger: LoggerConstructor = class BrowserLogger extends PinoLogger {
  protected override getPinoOptions(name: string, config: LoggerConfig): pino.LoggerOptions {
    return {
      ...super.getPinoOptions(name, config),
      browser: {
        disabled: config.disabled,
        ...(config.datadog && {
          ...this.getDatadogOptions(name, config.level, config.datadog, config.forceConsole)
        })
      },
      transport: undefined // disallow custom transports in the browser
    };
  }

  private getDatadogOptions(
    name: string,
    level: LoggerConfig['level'],
    datadog: DatadogLogger | DatadogConfig,
    forceConsole = false
  ): pino.LoggerOptions['browser'] {
    return {
      serialize: false,
      ...(forceConsole ? undefined : { write: () => null }),
      formatters: {
        level: label => ({ level: label })
      },
      transmit: {
        send: createDatadogSend(name, datadog),
        level
      }
    };
  }
};
